import React from "react";
import { FormattedMessage } from "react-intl";
import { Box } from "@material-ui/core";

import { useStyles } from "../style";
import { useAuthenticationContext } from "../../../context/UserContext";
import { ICIPAdminScreen } from "../../icip_admin_screen/ICIPAdminScreen";
import { HomeScreen } from "../../home/HomeScreen";

const CustomLink = () => {
  const classes = useStyles();
  const [authUser, token] = useAuthenticationContext();

  const computeRedirectionLink = () => {
    const isConnected = Boolean(token !== null) && Boolean(authUser !== null);

    if (isConnected && authUser.isAdmin()) {
      return ICIPAdminScreen.routeName;
    }

    return HomeScreen.routeName;
  };

  return (
    <Box mb={4} style={{ textAlign: "center" }} className={classes.customLink}>
      <a href={computeRedirectionLink()}>
        <FormattedMessage id="sharedScreen.gotToHome" />
      </a>
    </Box>
  );
};

export default CustomLink;
